module.exports = __webpack_public_path__ + "img/logo2.a33fd13e.png";